// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_pageProposta__AOFOZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-between ;
}

`, "",{"version":3,"sources":["webpack://./src/pages/PropostaEmAnalise/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".pageProposta {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: space-between ;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageProposta": `styles_pageProposta__AOFOZ`
};
export default ___CSS_LOADER_EXPORT___;
